import type { GasPayload } from '@atlaskit/analytics-gas-types';
import type { UseInputIntentResult } from '@atlassian/search-intent-detection/use-input-intent';

type IntentResponse = NonNullable<UseInputIntentResult['intent']>;

export type CounterfactualIntentDecisionAttributes = {
	detectorSource: UseInputIntentResult['source'];
	enginePrediction: IntentResponse['type'] | undefined;
	modelId: IntentResponse['modelVersion'];
	patternType: IntentResponse['pattern'] | undefined;
};

export const onCounterfactualIntentDecision = ({
	attributes,
}: {
	attributes: CounterfactualIntentDecisionAttributes & Record<string, unknown>;
}): GasPayload => ({
	eventType: 'track',
	action: 'decided',
	actionSubject: 'searchChatCounterfactualIntent',
	attributes,
});
